"use client";

import { Box, Chip, Skeleton } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

export default function QuickReplies({ options, onSelect, disabled }) {
  const theme = useTheme();
  if (!options?.length) return null;

  return (
    <Box
      role="group"
      aria-label="Suggested topics"
      sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1 }}
    >
      {options.map((option) => (
        <Chip
          key={option}
          label={option}
          variant="outlined"
          clickable
          disabled={disabled}
          onClick={() => onSelect(option)}
          sx={{
            height: "auto",
            py: 0.5,
            borderRadius: "10px",
            borderColor: alpha(theme.palette.text.primary, 0.35),
            color: "text.primary",
            fontSize: "0.85rem",
            "& .MuiChip-label": { whiteSpace: "normal" },
            "&:hover": {
              borderColor: theme.palette.background.accent || theme.palette.primary.main,
            },
          }}
        />
      ))}
    </Box>
  );
}

const SKELETON_CHIP_WIDTHS = [118, 96, 132, 84];

export function QuickRepliesSkeleton() {
  return (
    <Box
      aria-hidden
      sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1 }}
    >
      {SKELETON_CHIP_WIDTHS.map((width) => (
        <Skeleton
          key={width}
          variant="rounded"
          width={width}
          height={28}
          sx={{ borderRadius: "10px" }}
        />
      ))}
    </Box>
  );
}
